import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element';
import { css } from '@adornis/chemistry/directives/css';
import '@adornis/chemistry/elements/components/x-chip';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('wtg-user-voice')
export class WTGUserVoice extends ChemistryLitElement {
  styles = () => ({ ':host': { flexBasis: '400px' } });

  @property({ reflect: true }) 'image-url' = '';
  @property({ reflect: true }) text = '';
  @property({ reflect: true }) name = '';
  @property({ reflect: true }) occupation = '';

  render() {
    return html`
      <x-flex horizontal space="lg" ${css({ height: '130px' })}>
        <x-flex ${css({ position: 'relative' })}>
          <x-image
            .value=${this['image-url']}
            ${css({ width: '130px', borderRadius: '50%', overflow: 'hidden' })}
            mode="width"
          ></x-image>
          <x-flex
            crossaxis-center
            space="xs"
            ${css({ position: 'absolute', top: '135px', right: '0', left: '0', margin: 'auto' })}
          >
            <x-chip ${css({ marginTop: '-20px', zIndex: '1', background: this.colors.secondary })}>
              ${this.name}
            </x-chip>
            <ge-mini> ${this.occupation} </ge-mini>
          </x-flex>
        </x-flex>
        <x-flex
          padding="sm"
          center
          ${css({
            marginLeft: '-100px',
            paddingLeft: '100px',
            borderRadius: this.sizes.borderRadius,
            boxShadow: this.shadows[1],
          })}
        >
          <ge-mini> <span ${css({ fontSize: '30px', fontWeight: 'bold' })}>“</span> ${this.text} </ge-mini>
        </x-flex>
      </x-flex>
    `;
  }
}
